import { Controller } from "@hotwired/stimulus";

// LOC-081: the job form's profession rows. "Add profession" shows the next
// hidden row (up to the five rendered); the x clears a row and hides it, and
// marks a saved row for destruction. Without JavaScript the first row is the
// only one shown and the job is saved with one profession.
export default class extends Controller {
  static targets = ["row", "add", "destroy"];

  connect() {
    this.toggleAdd();
  }

  add() {
    const next = this.rowTargets.find((row) => row.hidden);
    if (!next) return;

    next.hidden = false;
    const select = next.querySelector("select");
    if (select) select.focus();
    this.toggleAdd();
  }

  remove(event) {
    const row = event.target.closest("[data-locals-rows-target='row']");
    if (!row) return;

    const select = row.querySelector("select");
    if (select) select.value = "";
    const destroy = row.querySelector("[data-locals-rows-target='destroy']");
    if (destroy) destroy.value = "1";
    if (this.rowTargets.filter((r) => !r.hidden).length > 1) row.hidden = true;
    row.dispatchEvent(new Event("change", { bubbles: true }));
    this.toggleAdd();
  }

  toggleAdd() {
    if (this.hasAddTarget) this.addTarget.hidden = !this.rowTargets.some((row) => row.hidden);
  }
}
